import type { LicenceDraft } from './licence-draft.model';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof LicenceDraft, string>>;

/**
 * Pure business validation for a licence draft. The only rule mirrors the backend
 * contract (`UpdateLicenceRequestSchema`: `name` min length 1): a non-empty name.
 * No React, no Redux; trivially unit-testable.
 */
export function validateDraft(draft: LicenceDraft): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!draft.name.trim()) errors.name = 'A licence name is required.';
  return errors;
}
